import {
  FeaturedCard,
  Maybe,
  PathFeaturedCardData,
  UserSubscription,
} from "@onmo/graphql/graphql";
import { DEFAULT_LANGUAGE, getByLanguage } from "../utils/getLocalizedField";
import { getStatusInfo } from "./user";

export const getFeatureCardsMap = (
  featuredCardsData: { featuredCards: { items: FeaturedCard[] } } | undefined,
  ids: string[],
): Record<string, FeaturedCard> => {
  if (!featuredCardsData) return {};
  const idSet = new Set(ids);
  return featuredCardsData.featuredCards.items.reduce(
    (acc: Record<string, FeaturedCard>, card: FeaturedCard) => {
      if (card?.metadata.id && idSet.has(card.metadata.id)) {
        acc[card.metadata.id] = card;
      }
      return acc;
    },
    {},
  );
};

export const getFeaturedCardData = (
  data: FeaturedCard,
  language: string = DEFAULT_LANGUAGE,
) => {
  const title = getByLanguage<string>(data.title, language);
  const assets = getByLanguage<Record<string, string>>(data.assets, language);

  let description: string | undefined;
  const rawDescription = data.metadata?.description;
  if (rawDescription) {
    try {
      const parsed =
        typeof rawDescription === "string"
          ? JSON.parse(rawDescription)
          : rawDescription;
      description = getByLanguage<string>(parsed, language);
    } catch {
      description = rawDescription;
    }
  }

  return {
    id: data.metadata.id,
    title,
    assets,
    description,
    internalPath: (data.data as PathFeaturedCardData)?.internalPath,
  };
};

export const findFeaturedCardData = (items?: FeaturedCard[], id?: string) => {
  if (!items || !id) return undefined;
  const card = items.find((item) => item.metadata.id === id);
  return card ? getFeaturedCardData(card) : undefined;
};

export const getSubscriptionFeaturedCardId = (
  subscription: Maybe<UserSubscription> | undefined,
) => {
  if (!subscription) return [];
  const status = getStatusInfo(
    subscription?.status,
    subscription.validUntil,
    Boolean(subscription.isRecurring),
  );
  switch (status) {
    case "expire-soon":
    case "grace":
      return ["subscription_expiring_card"];
    case "expired":
      return ["subscription_expired_card"];
    case "not-subscribed":
      return ["activate_console_card"];
    default:
      return [];
  }
};
